import { api } from '../plugins/axios'

/**
 * Represents a startup method for a content app
 */
export default class ContentAppStartup {
  /**
   * fetches the required url and specific startup data
   *
   * @param materialId
   * @return {Promise<ContentAppStartup>}
   */
  static fetch (materialId) {
    return api.get(`/api/v1/materials/${materialId}/content-app/startup`).then(r => {
      return new ContentAppStartup(r.data)
    })
  }

  /**
   * Creates a startup
   *
   * @param {Object} data – the response of the route
   */
  constructor (data) {
    this._initObject = data.initObject
    this._contentApp = data.contentApp
  }

  /**
   * Checks if the app is hosted externally
   *
   * @return {boolean}
   */
  get isHostedExternally () {
    return !this._contentApp.hostedInternally
  }

  /**
   * The initialization object for the content app (the former window.sc2 content)
   *
   * @return {Object}
   */
  get initObject () {
    return this._initObject
  }

  /**
   * Returns the URL to open
   *
   * @return {String}
   */
  get url () {
    return this._contentApp.url
  }

  /**
   * Sends the init message to an iframe
   *
   * @param iframe
   */
  sendInitialization (iframe) {
    iframe.contentWindow.postMessage({
      command: 'scp.app.init',
      payload: this.initObject
    }, '*')
  }
}
